import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
    AlertType,
    AppUpdateState,
    addAlert,
    setAppUpdate,
} from "../framework/redux/slices/appSlice";
import { useAppDispatch, useAppSelector } from "../framework/redux/hooks";
import { useTranslation } from "react-i18next";
import { useInterval } from "usehooks-ts";

const fetchInterval = 5 * 60 * 1000; // 5 minutes

export const AppUpdateHandler = () => {
    const update = useAppSelector((state) => state.app.update);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const location = useLocation();

    useEffect(() => {
        if (update === AppUpdateState.Pending) {
            // Force reload on navigation
            window.location.reload();
        }
    }, [location.pathname]);

    useEffect(() => {
        if (update === AppUpdateState.Confirmed) {
            // Reload after confirm
            window.location.reload();
        }
    }, [update]);

    const onUpdate = () => {
        // Set to update to pending to trigger update on navigation.
        dispatch(setAppUpdate(AppUpdateState.Pending));

        // Display a notification or prompt the user to update the application
        dispatch(
            addAlert({
                message: t("common.updateAvailable"),
                duration: null,
                type: AlertType.AppUpdate,
                dialog: true,
            })
        );
    };

    const checkVersion = (forceUpdate: boolean) =>
        fetch(`${process.env.PUBLIC_URL}/version.json`, { cache: "reload" }) // Skip cache
            .then((res) => res.json())
            .then((res) => {
                if (
                    !!res?.version &&
                    (typeof version === "undefined" || res.version !== version)
                ) {
                    if (forceUpdate) {
                        window.location.reload();
                    } else {
                        onUpdate();
                    }
                }
            })
            .catch(console.error);

    useEffect(() => {
        void checkVersion(true);
    }, []);

    useInterval(() => void checkVersion(false), fetchInterval);

    return null;
};
